// Returns distance in meters between two lat/lon points (Haversine formula)
export function haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6_371_000;
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;
  const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function getAccuratePosition(
  minAccuracy = 50,
  maxWait = 10000
): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    const results: GeolocationPosition[] = [];
    let done = false;

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        results.push(position);
        if (position.coords.accuracy <= minAccuracy) {
          done = true;
          navigator.geolocation.clearWatch(watchId);
          resolve(position);
        }
      },
      (error) => {
        done = true;
        navigator.geolocation.clearWatch(watchId);
        reject(error);
      },
      { enableHighAccuracy: true, timeout: maxWait, maximumAge: 0 }
    );

    setTimeout(() => {
      if (!done) {
        done = true;
        navigator.geolocation.clearWatch(watchId);
        if (results.length > 0) {
          const best = results.reduce((a, b) =>
            a.coords.accuracy < b.coords.accuracy ? a : b
          );
          resolve(best);
        } else {
          reject(new GeolocationPositionError());
        }
      }
    }, maxWait);
  });
}
